import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useMemberProfileStore = defineStore('memberProfile', () => {
    const all = ref({ data: [] });

    const current = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/member-profiles', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/member-profiles', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/member-profiles/' + params.hash, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/member-profiles/' + params.hash);
    };

    const archiveOrActivateProfile = (params) => {
        return axios.post(`/api/v1/member-profiles/${params.hash}/archive-activate`);
    };

    const hasActiveProfile = async () => {
        const response = await axios.get('/api/v1/member-profiles/check-active');
        return response.data;
    };

    const generateProfile = async (params) => {
        return axios.post(`/api/v1/member-profiles/${params.hash}/generate`);
    };

    const downloadPdf = async (hash, radarImage, fullName) => {
        const response = await axios.post(
            `/api/v1/member-profiles/${hash}/download-pdf`,
            { radar_image: radarImage },
            { responseType: 'blob' }
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `Profile-${fullName}.pdf`;
        a.click();

        URL.revokeObjectURL(url);
    };

    const downloadAssessmentExport = async (params) => {
        const url = `/api/v1/member-profiles/${params}/download-assessment-export`;
        window.location.href = url;
    };

    const downloadDomainDocument = async (hash, domain) => {
        const url = `/api/v1/member-profiles/${hash}/domain-documents/${domain}`;
        window.location.href = url;
    };

    const updateSummaryContent = (hash, params) => {
        return axios.patch(`/api/v1/member-profiles/${hash}/summary`, params);
    };

    const updateSingleDomain = (profileHash, domainHash, params) => {
        return axios.patch(`/api/v1/member-profiles/${profileHash}/domains/${domainHash}`, params);
    };

    const updateRecommendations = (hash, params) => {
        return axios.patch(`/api/v1/member-profiles/${hash}/recommendations`, params);
    };

    return {
        all,
        current,
        reset,
        search,
        store,
        update,
        destroy,
        archiveOrActivateProfile,
        hasActiveProfile,
        generateProfile,
        downloadPdf,
        downloadAssessmentExport,
        downloadDomainDocument,
        updateSummaryContent,
        updateSingleDomain,
        updateRecommendations
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMemberProfileStore, import.meta.hot));
}
